import React from 'react';
import { motion } from 'framer-motion';
import { PricingCTA } from './PricingCTA';
export function HeroSection() {
  return <section className="w-full max-w-3xl mx-auto px-6 py-16 md:py-24" data-id="element-122">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="space-y-8" data-id="element-123">
        {/* Emotional Hook / Opening Lead */}
        <div className="prose prose-lg md:prose-xl font-serif text-navy leading-relaxed mb-12 border-l-4 border-teal pl-6 italic" data-id="element-124">
          <p className="text-2xl md:text-3xl font-medium" data-id="element-125">
            No estás “mal organizado”.
          </p>
          <p className="text-2xl md:text-3xl font-medium mt-4" data-id="element-126">
            Estás agotado de decidir.
          </p>
        </div>

        <div className="text-center space-y-6" data-id="element-127">
          <h1 className="text-5xl md:text-7xl font-black text-navy tracking-tight" data-id="element-128">
            PLANEACIÓN 10X
          </h1>
          <h2 className="text-xl md:text-2xl text-gray-700 font-medium max-w-2xl mx-auto" data-id="element-129">
            Crea mejores lecciones 10 veces más rápido
            <span className="block text-teal font-bold mt-1" data-id="element-130">
              (prepa/bachiller, cualquier materia)
            </span>
          </h2>
          <p className="text-lg text-gray-600 font-serif italic" data-id="element-131">
            Sistema: Mapa 3C + Bloque 7
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="relative my-12" data-id="element-132">
          <div className="absolute inset-0 bg-teal/10 blur-3xl rounded-full transform scale-75 z-0" data-id="element-133"></div>
          <img src="https://cdn.magicpatterns.com/uploads/i6mmmePn6by5xy8P5TphdZ/heylloyd-image-1770589493369.png" alt="Planeación 10X Tablet Mockup" className="relative z-10 w-full max-w-lg mx-auto drop-shadow-2xl rounded-xl" data-id="element-134" />
        </motion.div>

        <div className="flex flex-col items-center gap-4 text-center" data-id="element-135">
          <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-136">
            <span className="px-4 py-1 bg-navy/5 text-navy rounded-full text-sm font-semibold" data-id="element-137">
              PDF + Plantillas Editables
            </span>
            <span className="px-4 py-1 bg-teal/10 text-teal-700 rounded-full text-sm font-bold" data-id="element-138">
              299 MXN
            </span>
          </div>

          <PricingCTA variant="compact" data-id="element-139" />
        </div>
      </motion.div>
    </section>;
}